<script lang="ts">
	import { Splide, SplideSlide } from '@splidejs/svelte-splide';
	import '@splidejs/svelte-splide/css';
	export let data: any = [];
	$: items = data.data;
</script>

<Splide
	options={{
		gap: 0,
		perPage: 3,
		perMove: 1,
		type: 'loop',
		arrows: true,
		pagination: false,
		autoplay: true,
		interval: 3000,
		loop: true,
		breakpoints: {
			1024: {
				perPage: 3,
				perMove: 1,
				gap: 0
			},
			768: {
				perPage: 2,
				perMove: 1,
				gap: 0
			},
			480: {
				perPage: 1,
				perMove: 1,
				gap: 0
			}
		}
	}}
>
	{#each items as item}
		<SplideSlide>
			<a href="/wellness/{item?.slug}">
				<div class="relative" style="aspect-ratio: 17/20;">
					<img
						src={item?.images[0]?.path}
						alt={item?.images[0]?.path}
						class="w-full h-full object-cover"
					/>
					<div
						class="absolute bottom-0 h-full w-full"
						style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.70) 0%, rgba(0, 0, 0, 0.00) 100%);"
					></div>
					<div class="absolute bottom-10 px-10">
						<h1 class="text-white text-2xl uppercase">{item?.title}</h1>
					</div>
				</div>
			</a>
		</SplideSlide>
	{/each}
</Splide>
